import { ScrollingModule } from "@angular/cdk/scrolling";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { BackButtonComponent } from "src/app/shared/component/back-button/back-button.component";
import { SharedModule } from "src/app/shared/shared.module";
import { CompleteRegistrationComponent } from "./complete-registration.component";
import { CompleteRegistrationRoutingModule } from "./complete-registration.routing";

const MY_DATE_FORMAT = {
    parse: {
        dateInput: "DD/MM/YYYY" // this is how your date will be parsed from Input
    },
    display: {
        dateInput: "DD/MM/YYYY", // this is how your date will get displayed on the Input
        monthYearLabel: "MMMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};

@NgModule({
    declarations: [CompleteRegistrationComponent],
    imports: [
        CommonModule,
        SharedModule,
        MatToolbarModule,
        MatStepperModule,
        MatCardModule,
        MatFormFieldModule,
        ScrollingModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        TranslateModule,
        NgxMaskModule.forRoot(),
        CompleteRegistrationRoutingModule,
        NgxSpinnerModule,
        FlexModule,
        FlexLayoutModule,
        BackButtonComponent
    ],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CompleteRegistrationModule {}
